import { render } from "./RateModifierServices.vue?vue&type=template&id=3f2d92f2"
import script from "./RateModifierServices.vue?vue&type=script&lang=js"
export * from "./RateModifierServices.vue?vue&type=script&lang=js"

import exportComponent from "/home/oawms/app/ru_releases/20261004163500/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__